export default {"src":"/_next/static/image/public/icons/arrow-big-black.230fd856686d79143bed71e30684a1db.svg","height":30,"width":30};